import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateAgentCategoryDto } from './create-agent-category.dto';

/**
 * Update agent category DTO
 */
export class UpdateAgentCategoryDto extends CreateAgentCategoryDto {
	@TransformInt()
	id!: number;
}
